import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import MaterialTable from "material-table";
import { NotificationManager } from "react-notifications";
import MainService from "../../Common/MainService";
import { Button } from "@mui/material";
import LiveMonitor from "./Fleet/LiveMonitor";
import VehicleStatus from "./VehicleStatus/VehicleStatus";
import Main from "../../Common/MainService";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 250,
  },
  gridRoot: {
    flexGrow: 1,
  },
  control: {
    padding: theme.spacing(2),
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
}));

export default function LiveMonitoringComponent() {
  const [viewFleet, setViewFleet] = useState(false);
  const [viewVehicle, setViewVehicle] = useState(true);
  const [userTypeValue, setUserTypeValue] = useState("");
  const { user } = Main.getLocalData();
  const { username, parentId } = user;

  const UserRole = localStorage.getItem("UserRole");

  const fleetStatusHandler = () => {
    setViewFleet(true);
    setViewVehicle(false);
  };

  const vehicleStatusHandler = () => {
    setViewVehicle(true);
    setViewFleet(false);
  };

  const getUserType = () => {
    Main.getConsumerUserType(parentId, username)
      .then((data) => {
        setUserTypeValue(data);
      })
      .catch((e) => {
        return NotificationManager.error(e);
      });
  };
  useEffect(() => {
    getUserType();
  }, [userTypeValue]);
  return (
    <>
      {userTypeValue === "LogisticsProvider" && (
        <div className="topHeadersWrapper">
          {(UserRole === "BASIC" ||
            UserRole === "STANDARD" ||
            UserRole === "PREFFERED" ||
            UserRole === "PREMIUM" ||
            UserRole === "ADMIN") && (
            <div className="topHeaders">
              <Button
                color="success"
                size="large"
                variant="contained"
                onClick={() => {
                  vehicleStatusHandler();
                }}
              >
                Vehicle
              </Button>
            </div>
          )}
          &nbsp;
          {(UserRole === "PREFFERED" ||
            UserRole === "PREMIUM" ||
            UserRole === "ADMIN") && (
            <div className="topHeaders">
              <Button
                color="success"
                size="large"
                variant="contained"
                onClick={() => {
                  fleetStatusHandler();
                }}
              >
                Fleet
              </Button>
            </div>
          )}
        </div>
      )}

      {viewFleet && <LiveMonitor />}
      {viewVehicle && <VehicleStatus assetId={"zeusVehicle"}/>}
    </>
  );
}
